import React from 'react';

import { flagStyles } from '../settings';

const SvgCC = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-888px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgCC;
